"use client";

import { useTheme } from "next-themes";

export function useColorMode() {
  const { resolvedTheme, setTheme, forcedTheme } = useTheme();
  const colorMode = forcedTheme || resolvedTheme;
  const toggleColorMode = () => {
    setTheme(resolvedTheme === "dark" ? "light" : "dark");
  };

  return {
    colorMode: colorMode,
    setColorMode: setTheme,
    toggleColorMode
  };
}

export default useColorMode;
